import { useEffect, useMemo, useState } from "react";

import { FormikValues, useFormikContext } from "formik";

import { SelectDataType } from "@sso/components/Form";
import { FormikTextInput } from "@sso/components/Formik";
import FormikSelectWithBlur from "@sso/components/Formik/FormikSelectWtihBlur";
import { Currency, LicenceType, PricingRuleCreateRequest, PricingSummaryKeys } from "@sso/types";

import AddCurrencyApiRulesForm from "./addCurrencyApiPricingForm";
import AddCurrencyRules from "./AddCurrencyRules";

interface EditMultiCurrencyPricingFormProps {
  rules: PricingRuleCreateRequest[];
}

const EditMultiCurrencyPricingForm = ({ rules }: EditMultiCurrencyPricingFormProps) => {
  const { values } = useFormikContext<FormikValues>();

  const availableCurrencies = useMemo(() => {
    const map = new Map(rules.map(rule => [rule.currency?.code, rule.currency]));
    return Array.from(map.values());
  }, [rules]);

  const currencyOptions = useMemo(() => {
    return rules
      .map(rule => rule.currencyCode)
      .filter((value, index, self) => self.indexOf(value) === index)
      .map(code => ({
        label: code,
        value: code,
        key: code,
      })) as SelectDataType[];
  }, [rules]);

  const [selectedCurrency, setSelectedCurrency] = useState<Currency | undefined>();

  useEffect(() => {
    if (!availableCurrencies || !availableCurrencies.length) {
      return;
    }

    setSelectedCurrency(availableCurrencies.find(currency => currency?.code === values.currencyCode));
  }, [availableCurrencies]);

  return (
    <>
      <FormikTextInput type="date" name={PricingSummaryKeys.DATE_OF_EFFECT} label="Date of Effect" />
      <FormikSelectWithBlur
        onChange={value => {
          const selected = availableCurrencies.find(currency => currency?.code === value);
          setSelectedCurrency(selected);
        }}
        name={"currencyCode"}
        label="Currency"
        items={currencyOptions}
      />
      {(values.licenceType === LicenceType.CONCURRENT || values.licenceType === LicenceType.SINGLE_USER) && (
        <AddCurrencyRules
          fieldAccessor="pricingRules"
          currency={selectedCurrency}
          rules={values.pricingRules ?? []}
          licenceType={values.licenceType}
        />
      )}
      {values.licenceType === LicenceType.API && values.pricingRules && (
        <AddCurrencyApiRulesForm currency={selectedCurrency} />
      )}
    </>
  );
};

export default EditMultiCurrencyPricingForm;
